import clsx from 'clsx';
import { Flex, Table } from '@mantine/core';
import SortBtn from '@/components/common/table/sort-btn';
import TableSkeleton from '@/components/common/skeleton-effect/table-skeleton';
import StatusMsg from '@/components/common/status-msg';
import { formateNumber } from '@/lib/utils/currency';
import { SecBoxLoader } from '@/components/layout/sec-box';

const ActiveUsersData = ({ dashboardTxt, loading, error, userData }) => {
    const tableRow = (v, i) => (
        <Table.Tr key={i}>
            <Table.Td>
                <Flex align="center" gap="sm">
                    <span>{v?.username}</span>
                </Flex>
            </Table.Td>
            <Table.Td>
                <span>{v?.remoteId?.split('_')[1]}</span>
            </Table.Td>
            <Table.Td>
                <span>{formateNumber(v?.balance)}</span>
            </Table.Td>
        </Table.Tr>
    );

    return (
        <>
            {loading ? (
                <SecBoxLoader />
            ) : error?.message ? (
                <div className="full_screen_msg sec_box_msg">
                    <StatusMsg title={error?.message} variant={error?.variant} />
                </div>
            ) : (
                <Table.ScrollContainer className={clsx('theme_table radius_none sec_box_table')} minWidth="31.25rem" offsetScrollbars={false}>
                    <Table striped withTableBorder>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th style={{ width: '40%', minWidth: '14.375rem' }}>
                                    <span>{dashboardTxt?.username} </span>
                                </Table.Th>
                                <Table.Th style={{ width: '30%' }}>
                                    <span> {dashboardTxt?.userId} </span>
                                </Table.Th>
                                <Table.Th style={{ width: '30%' }}>
                                    <span> {dashboardTxt?.credites} </span>
                                </Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>{userData?.map((v, i) => tableRow(v, i))}</Table.Tbody>
                    </Table>
                </Table.ScrollContainer>
            )}
        </>
    );
};

export default ActiveUsersData;
